import type { FC, PropsWithChildren } from 'react';
import { SiteProvider } from '@anywayseo/tools';

import { useSiteMetadata } from 'hooks';
import { ExpertImage, LogoImage } from 'components/images';
import HeaderToolbar from 'components/header-toolbar';
import FooterExtra from 'components/footer-extra';
import { legalRoutes } from 'routes';


const PageWrapper: FC<PropsWithChildren> = ({ children }) => {
  const siteMetadata = useSiteMetadata();

  return (
    <SiteProvider
      metadata={siteMetadata}
      configs={{
        header: {
          toolbar: <HeaderToolbar />,
        },
        footer: {
          navigation: legalRoutes,
          extra: <FooterExtra />,
          showDisclaimer: false,
        },
      }}
      assets={{
        images: {
          logo: <LogoImage />,
          expert: <ExpertImage />,
        },
      }}
    >
      {children}
    </SiteProvider>
  );
};

export default PageWrapper;
